import styled from 'styled-components'
import Mono from '../../../ui/Mono/Mono'
import PerPageSelect from './PerPageSelect'
import Pager from './Pager'

export interface GridFooterProps {
  rangeStart: number
  rangeEnd: number
  total: number
  page: number
  pageCount: number
  perPage: number
  perPageOptions: number[]
  onPage: (page: number) => void
  onPerPage: (value: number) => void
}

export const GridFooter = ({
  rangeStart,
  rangeEnd,
  total,
  page,
  pageCount,
  perPage,
  perPageOptions,
  onPage,
  onPerPage,
}: GridFooterProps) => (
  <Root>
    <Range>
      מציג{' '}
      <b>
        {rangeStart}–{rangeEnd}
      </b>
    </Range>
    <Spacer />
    <Total>
      סה״כ <b>{total}</b>
    </Total>
    <PerPageSelect value={perPage} options={perPageOptions} onChange={onPerPage} />
    {/* Mobile-only: shown-of-total on its own row above the pager. */}
    <MobileRange>
      מציג{' '}
      <b>
        {rangeStart}–{rangeEnd}
      </b>{' '}
      מתוך <b>{total}</b>
    </MobileRange>
    <Pager page={page} pageCount={pageCount} onPage={onPage} />
  </Root>
)

export default GridFooter

const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 18px;
  border-top: 1px solid ${({ theme }) => theme.colors.line};
  background: ${({ theme }) => theme.colors.surface};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    justify-content: space-between;
    padding: 10px 14px;
  }
`

const Range = styled(Mono)`
  font-size: ${({ theme }) => theme.text.sm};
  color: ${({ theme }) => theme.colors.ink3};

  b {
    color: ${({ theme }) => theme.colors.ink};
    font-weight: 600;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: none;
  }
`

const Total = styled(Mono)`
  font-size: ${({ theme }) => theme.text.sm};
  color: ${({ theme }) => theme.colors.ink3};

  b {
    color: ${({ theme }) => theme.colors.ink};
    font-weight: 600;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: none;
  }
`

const Spacer = styled.div`
  flex: 1;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: none;
  }
`

const MobileRange = styled(Mono)`
  display: none;
  font-size: ${({ theme }) => theme.text.sm};
  color: ${({ theme }) => theme.colors.ink3};

  b {
    color: ${({ theme }) => theme.colors.ink};
    font-weight: 600;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
`
